import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import TopBar from "./TopBar";
import Navbar from "./Navbar";
import Footer from "./Footer";
import MobileActionBar from "./MobileActionBar";
import CouponPopup from "./CouponPopup";
import { useLenis } from "../../hooks/useLenis";
import { useOrganizationSchema } from "../SEO";

export default function Layout({ children }) {
  useLenis();
  useOrganizationSchema();
  const loc = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [loc.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-paper">
      <TopBar />
      <Navbar />
      <main className="flex-1 pb-20 md:pb-0">{children}</main>
      <Footer />
      <MobileActionBar />
      <CouponPopup />
    </div>
  );
}
